const useTabBarStyle = () => {
  const tabStyle = {
    Tab: {
      style: ({ $isActive }) => ({
        borderRadius: '0.5rem 0.5rem 0 0',
        marginRight: '0.3rem',
        backgroundColor: $isActive ? 'white' : 'lightgrey',
        fontWeight: 'bold',
        fontSize: '1rem',
      }),
    },
    TabPanel: {
      style: () => ({
        backgroundColor: 'white',
        borderRadius: '0 0.5rem 0.5rem 0.5rem',
        paddingTop: '24px',
        paddingBottom: '24px',
        paddingLeft: '24px',
        paddingRight: '24px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '48px',
        alignSelf: 'stretch',
      }),
    },
  }

  const addButtonStyle = {
    BaseButton: {
      style: {
        backgroundColor: 'lightgrey',
        color: 'rgb(65, 71, 78);',
        borderBottomLeftRadius: '0',
        borderBottomRightRadius: '0',
        fontWeight: 'bold',
        ':hover': {
          backgroundColor: 'white',
          color: 'rgb(65, 71, 78);',
        },
      },
    },
  }

  const tabsOverrides = {
    TabBorder: {
      style: () => ({
        height: '0rem',
      }),
    },
    TabHighlight: {
      style: () => ({
        display: 'none',
      }),
    },
    TabList: {
      style: () => ({
        flexGrow: '0',
      }),
    },
    EndEnhancerContainer: {
      style: () => ({
        marginLeft: '0.1rem',
      }),
    },
  }

  const mainContainerStyle = {
    display: 'flex',
    flexDirection: 'inline-flex',
    gap: '24px',
    alignItems: 'flex-start',
  }

  const tabsContainerStyle = {
    width: '75%',
    flexDirection: 'column',
    alignItems: 'flex-start',
  }

  const rightColumnContainerStyle = {
    width: '25%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  }

  const rightColumnElementStyle = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: '1rem',
    backgroundColor: 'white',
    borderRadius: '0.5rem',
    paddingTop: '1rem',
    paddingBottom: '1rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
  }

  const rightColumnElementStatelessStyle = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: '1rem',
    backgroundColor: 'white',
    borderRadius: '0.5rem',
  }

  return {
    tabStyle,
    tabsOverrides,
    mainContainerStyle,
    tabsContainerStyle,
    rightColumnContainerStyle,
    rightColumnElementStyle,
    rightColumnElementStatelessStyle,
    addButtonStyle,
  }
}

export default useTabBarStyle
